import React from 'react';
import { useLocation } from 'react-router-dom';

import Button from '../../atoms/Button/Button';
import CodeIcon from '../../atoms/CodeIcon/CodeIcon';
import { event } from '../../../services/googleAnalytics4';
import useTranslation from '../../hooks/useTranslation';
import useTransitionalNavigate from '../../hooks/useTransitionalNavigate';
import { ROUTES } from '../../constants/routes.js';

import './CodeSignIn.scss';

interface CodeSignInProps {
  username?: String;
}

function CodeSignIn({ username = '' }: CodeSignInProps) {
  const { translateText } = useTranslation();
  const { search } = useLocation();

  const navigate = useTransitionalNavigate();

  const newState = { username };

  const goToSignInCodePage = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    event('code_signin', 'Sign in with code', 'Link', 'Sign in with code button click');
    navigate({ pathname: ROUTES.SIGNIN_CODE, search }, { state: newState });
  };

  const buttonText = translateText('Sign in with code');

  return (
    <Button
      id="codeSignInBttn"
      type="button"
      className="ies-btn tertiary cta-button"
      onClick={goToSignInCodePage}
    >
      <div className="code-logo">
        <CodeIcon />
      </div>
      {buttonText}
    </Button>
  );
}

export default CodeSignIn;
